export default {
  title: 'Artigos',
  description: 'Gerencie os artigos do seu blog.',
  labels: {
    new: 'Novo Artigo',
  },
  form: {
    title: 'Cadastro de Artigo'
  },
  groups: {
    filter: 'Filtro',
    generalData: 'Dados gerais',
  },
  fields: {
    content: 'Conteúdo',
    is_draft: 'Rascunho',
    is_published: 'Publicado',
    language: 'Idioma',
    layout: 'Layout',
    max_depth: 'Limite de itens',
    name: 'Nome da artigo',
    page_type: 'Tipo de página',
    plan: 'Plano',
    preview:'Preview',
    slug: 'Slug',
    status: 'Status',
    url: 'URL',
    website: 'Website',
  }
};
